var _require = require('./publish.escape'),
  escapeHTML = _require.escapeHTML;
var flow = require('./publish.flow');
var selectSlide = require('./publish.select');
var signSlide = require('./publish.sign');
var verifySlide = require('./publish.verify');
var shareSlide = require('./publish.share');
var premiumSlide = require('./publish.premium');
var slides = {
  select: selectSlide,
  identity: signSlide,
  sign: signSlide,
  verify: verifySlide,
  share: shareSlide,
  premium: premiumSlide
};
function primary(state) {
  switch (state.step) {
    case 'select':
      return {
        label: 'Continue',
        action: 'advance'
      };
    case 'identity':
      return null;
    case 'sign':
      return {
        label: 'Sign',
        action: 'advance',
        disabled: !state.identified
      };
    case 'verify':
      return {
        label: 'Continue',
        action: 'advance',
        disabled: !flow.requiredComplete(state)
      };
    case 'share':
      return null;
    case 'premium':
      {
        var from = state.history[state.history.length - 1];
        if (from && from !== 'select') {
          return {
            label: 'Back to signing',
            action: 'back'
          };
        }
        return {
          label: 'Continue with Free',
          action: 'advance'
        };
      }
    default:
      return {
        label: 'Continue',
        action: 'advance'
      };
  }
}
function publishTemplate(state) {
  var slide = (slides[state.step] || selectSlide)(state);
  var action = primary(state);
  var heading = slide.title ? "<h3 class=\"title\">".concat(escapeHTML(slide.title), "</h3>") : '';
  var subtitle = slide.subtitle ? "<p class=\"subtitle\">".concat(escapeHTML(slide.subtitle), "</p>") : '';
  var back = state.step === 'share' ? !state.finalized && state.history.length ? "<button type=\"button\" class=\"saito-button-square\" data-publish-action=\"back\" aria-label=\"Back\"><i class=\"fa-solid fa-arrow-left\" aria-hidden=\"true\"></i></button>" : '<span class="spacer"></span>' : state.history.length ? "<button type=\"button\" class=\"saito-button-square\" data-publish-action=\"back\" aria-label=\"Back\"><i class=\"fa-solid fa-arrow-left\" aria-hidden=\"true\"></i></button>" : state.step === 'select' ? '' : '<span class="spacer"></span>';
  var forward = state.step === 'share' ? '<span class="spacer"></span>' : action ? "<button type=\"button\" class=\"".concat(action.disabled ? 'saito-button-secondary' : 'saito-button-primary', "\" data-publish-action=\"").concat(action.action, "\"").concat(action.disabled ? ' disabled' : '', ">").concat(escapeHTML(action.label), "</button>") : '<span class="spacer"></span>';
  return "\n    <div class=\"saitosign-publish\">\n      <div class=\"content\">\n        <div class=\"viewport\">\n          <div id=\"saitosign-publish-step\" class=\"step\" data-step=\"".concat(escapeHTML(state.step), "\">\n            ").concat(heading, "\n            ").concat(subtitle, "\n            <div class=\"stage\">").concat(slide.body, "</div>\n          </div>\n        </div>\n        <div class=\"actions\">\n          <div class=\"actions-left\">").concat(back, "</div>\n          ").concat(forward, "\n        </div>\n      </div>\n    </div>\n  ");
}
module.exports = publishTemplate;